import { Injectable } from '@angular/core';
import { Observable, Subject, Subscriber } from 'rxjs';
import { LocalStorageService } from './local-storage-service.service';
import { CartService } from '../generate-client/api/cart.service';
import { environment } from 'src/environments/environment';
import { CartDto } from '../generate-client';

@Injectable({
  providedIn: 'root'
})
export class CartQantityService {
  cartQantity = new Subject<any>();
  quantity: number = 0
  constructor(
    private _localStorageService: LocalStorageService,
    private _cartService: CartService
  ) { }

  updateCartQuantity() {

    let id = parseInt(this._localStorageService.getUserId());

    this._cartService.apiCartGetMyCartGet(id).subscribe((response: CartDto) => {

      this.quantity = 0

      response.details.forEach(element => {
        this.quantity += element.nmQuantity;
      });

      this.cartQantity.next({
        quantity: this.quantity
      });

      if (this.quantity <= 0 || environment.storeId != response.cdStore) {
        
        this._localStorageService.clearCartData();

        this._localStorageService.clearCartNo();
      }
    });
  }
}